import React from 'react';
import { StyleSheet } from 'react-native';

import RewardMysteryGiftIcon from '@/assets/icons/rewardMysteryGift';
import RewardNoSweatIcon from '@/assets/icons/rewardNoSweat';
import RewardProfitBoostIcon from '@/assets/icons/rewardProfitBoost';
import WalletBetrBucksIcon from '@/assets/icons/wallet-betr-bucks';
import { PromoTag, PromoTagLabel } from '@/components/PromoTag';
import { ds } from '@/components/lib/design.system';
import { withOpacity } from '@/styles/styles';

import { PackageReward, PackageRewardKind } from '../utils/coin-package-rewards';

const ICON_SIZE = 16;

const REWARD_ICONS: Record<PackageRewardKind, React.FC<{ size?: number }>> = {
    bonus: WalletBetrBucksIcon,
    profit_boost: RewardProfitBoostIcon,
    no_sweat: RewardNoSweatIcon,
    mystery_gift: RewardMysteryGiftIcon,
};

export const PackageRewardIcon = ({ kind, size = ICON_SIZE }: { kind: PackageRewardKind; size?: number }) => {
    const Icon = REWARD_ICONS[kind];
    return <Icon size={size} />;
};

type Props = {
    reward: PackageReward;
};

export const PackageRewardBadge = ({ reward }: Props) => (
    <PromoTag style={styles.container} testID={`package-reward-${reward.id}`}>
        <PackageRewardIcon kind={reward.kind} />
        <PromoTagLabel color={ds.colorToken.text.brand} numberOfLines={1} flexShrink={1}>
            {reward.label}
        </PromoTagLabel>
    </PromoTag>
);

const styles = StyleSheet.create({
    container: {
        backgroundColor: withOpacity(ds.colorValue.background.brand.emphasis, 0.15),
    },
});
